module.exports = __webpack_public_path__ + "1011b11b4c1b5e81100ab7969e479cd4.svg";